import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-black text-white py-4 px-2 sm:px-6">
      <div className="container mx-auto">
        <div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 md:gap-6 gap-4 text-center"
          dir="rtl"
        >
          <div className="md:col-span-1 md:flex md:flex-col md:justify-around items-center">
            <div className="footerFirstPic">
              <img src="/images/logo-dark-1.png" alt="Logo" className="h-12" />
            </div>

            <div className="footerSecondPic hidden lg:block">
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=494354&Code=BqLIinnP6wokeU1Mrs0VBr8AfEWWT0ef"
              >
                <img
                  referrerPolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=494354&Code=BqLIinnP6wokeU1Mrs0VBr8AfEWWT0ef"
                  alt=""
                  className="h-12"
                  style={{ cursor: "pointer" }}
                  code="BqLIinnP6wokeU1Mrs0VBr8AfEWWT0ef"
                />
              </a>
            </div>
          </div>
          <div className="enamad flex justify-center  md:hidden">
            <a
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=494354&Code=BqLIinnP6wokeU1Mrs0VBr8AfEWWT0ef"
            >
              <img
                referrerPolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=494354&Code=BqLIinnP6wokeU1Mrs0VBr8AfEWWT0ef"
                alt="Enamad"
                className="h-8"
                style={{ cursor: "pointer" }}
              />
            </a>
          </div>

          <div className="md:col-span-2 text-center hidden md:block">
            <h3 className="text-base sm:text-base md:text-lg sm:p-2 font-semibold mb-2">
              درباره‌ی اسپاد سرور
            </h3>
            <p className="text-sm text-justify p-2">
              شرکت اسپاد سرور بهترین خدمات vps و هاست را با عملکرد بالا به
              مشتریان خود ارائه می‌دهد. خدمات ما به همین جا ختم نمی‌شود. ازجمله
              خدمات ابری، نرم افزاری، گیت لب ، ثبت دامنه و همچنین بهره‌مندی از
              منابع براساس نیاز کاربر از دیگر خدمات ما می‌باشد.
            </p>

            <div className="socialMedia mt-3 flex items-center justify-right">
              <a
                href="https://www.instagram.com/spadservers"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i>
                  <img
                    src="/../images/instagramm.png"
                    alt="Instagram"
                    className="h-6 ml-2"
                  />
                </i>
              </a>
              <a
                href="https://www.twitter.com/spadservers"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i>
                  <img
                    src="/../images/twitterMain.png"
                    alt="Twitter"
                    className="h-6 ml-2"
                  />
                </i>
              </a>
              <a
                href="https://www.linkedin.com/company/spad-cloud"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i>
                  <img
                    src="/../images/linkedinn.png"
                    alt="LinkedIn"
                    className="h-6 ml-2"
                  />
                </i>
              </a>
              <a
                href="https://www.youtube.com/spadservers"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i>
                  <img
                    src="/../images/youtubee.png"
                    alt="YouTube"
                    className="h-6 ml-2"
                  />
                </i>
              </a>
            </div>
          </div>

          <div className="md:col-span-1 md:mr-6 lg:mr-6 md:text-sm hidden md:block">
            <h3 className="text-lg font-bold mb-6">پشتیبانی</h3>
            <ul className="text-sm font-light">
              <li className="mt-2">
                <Link to="/Contact">ارتباط با ما</Link>
              </li>
              <li className="mt-2">
                <Link to="/AboutUs">داستان ما</Link>
              </li>
              <li className="mt-2">
                <Link to="/our-customers">مشتریان ما</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-1 md:mr-6 hidden md:block">
            <h3 className="text-lg font-semibold mb-2">بلاگ</h3>
            <ul className="text-sm">
              <Link to="https://spadserver.com/blog/">مجله ها</Link>
            </ul>
          </div>

          <div className="md:col-span-1 hidden md:block">
            <h3 className="text-lg font-semibold mb-2">همکاری با ما</h3>
            <ul className="text-sm">
              <li>
                <a
                  href="https://crm.spadserver.com/affiliates.php"
                  className="text-white hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Affilates
                </a>
              </li>
              <li className="mt-1">
                <a
                  href="https://spadserver.com/product/directadmin-reseller-hosting"
                  className="text-white hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  نمایندگی هاست
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="md:hidden block mt-4">
          <h3 className="text-[13px] md:text-lg sm:p-2 font-bold mb-2">
            درباره‌ی اسپاد سرور
          </h3>
          <p className="text-[12px] text-justify p-2 font-light">
            شرکت اسپاد سرور بهترین خدمات vps و هاست را با عملکرد بالا به مشتریان
            خود ارائه می‌دهد. خدمات ما به همین جا ختم نمی‌شود. ازجمله خدمات
            ابری، نرم افزاری، گیت لب ، ثبت دامنه و همچنین بهره‌مندی از منابع
            براساس نیاز کاربر از دیگر خدمات ما می‌باشد.
          </p>
        </div>
        <div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 md:gap-6 gap-4 md:hidden text-center mt-4"
          dir="rtl"
        >
          <div className="md:col-span-1 md:mr-6 lg:mr-6 md:text-sm block md:hidden">
            <h3 className="text-[14px] font-bold mb-6">پشتیبانی</h3>
            <ul className="text-sm font-light">
              <li className="mt-2 text-[12px]">
                <Link to="/Contact">ارتباط با ما</Link>
              </li>
              <li className="mt-2 text-[12px]">
                <Link to="/AboutUs">داستان ما</Link>
              </li>
              <li className="mt-2 text-[12px]">
                <Link to="/our-customers">مشتریان ما</Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-1 md:mr-6 block md:hidden">
            <h3 className="text-[14px] font-semibold mb-2">بلاگ</h3>
            <ul className="text-sm">
              <Link to="https://spadserver.com/blog/">مجله ها</Link>
            </ul>
          </div>
          <div className="md:col-span-1 block md:hidden">
            <h3 className="text-[14px] font-semibold mb-2 mt-2">همکاری با ما</h3>
            <ul className="text-sm">
              <li className="text-[12px]">
                <a
                  href="https://crm.spadserver.com/affiliates.php"
                  className="text-white hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Affilates
                </a>
              </li>
              <li className="mt-1 text-[12px]">
                <a
                  href="https://spadserver.com/product/directadmin-reseller-hosting"
                  className="text-white hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  نمایندگی هاست
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="mt-4 flex flex-col justify-center items-center pt-2"
          dir="ltr"
        >
          <div className="socialMedia mt-3 flex items-center md:hidden justify-right">
            <a
              href="https://www.instagram.com/spadservers"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="/../images/instagramm.png"
                  alt="Instagram"
                  className="h-6 ml-2"
                />
              </i>
            </a>
            <a
              href="https://www.twitter.com/spadservers"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="/../images/twitterMain.png"
                  alt="Twitter"
                  className="h-6 ml-2"
                />
              </i>
            </a>
            <a
              href="https://www.linkedin.com/company/spad-cloud"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="/../images/linkedinn.png"
                  alt="LinkedIn"
                  className="h-6 ml-2"
                />
              </i>
            </a>
            <a
              href="https://www.youtube.com/spadservers"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="/../images/youtubee.png"
                  alt="YouTube"
                  className="h-6 ml-2"
                />
              </i>
            </a>
          </div>
          <p className="footer-security text-[12px] text-center md:text-left mt-6">
            تمامی حقوق محفوظ است ©
          </p>
          <p className="text-white block text-[12px] text-center md:text-left sm:mt-4">
            طراحی شده توسط تیم نرم افزاری{" "}
            <span className="text-blue-500">
              {" "}
              <a href="https://spadserver.com">اسپاد سرور</a>
            </span>
          </p>
          <div className="flex space-x-2 space-x-reverse mt-2 md:mt-0">
            <a>
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                {/* YouTube Icon */}
              </svg>
            </a>
            <a
              href="#"
              aria-label="Instagram"
              className="text-white hover:text-gray-400"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                {/* Instagram Icon */}
              </svg>
            </a>
            <a
              href="#"
              aria-label="LinkedIn"
              className="text-white hover:text-gray-400"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                {/* LinkedIn Icon */}
              </svg>
            </a>
            <a
              href="#"
              aria-label="Twitter"
              className="text-white hover:text-gray-400"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                {/* Twitter Icon */}
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
